import { render, staticRenderFns } from "./collections.vue?vue&type=template&id=f01251ba"
import script from "./collections.js?vue&type=script&lang=js&external"
export * from "./collections.js?vue&type=script&lang=js&external"
import style0 from "./collections.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports